/* eslint-disable */
import { Buffer } from "buffer"

const map = (x, in_min, in_max, out_min, out_max) => {
	return ((x - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
}

const range = (start, end) => Array.from(Array(end + 1).keys()).slice(start)

const getVoltage = (bytes) => {
	const buffer = Buffer.from(bytes)
	const result = buffer.readIntLE(0, bytes.length)
	const voltage = map(result, -32768, 32767, -1, 1)

	return Math.round(voltage * 10e3) / 10e3
}

export const getAudioSamples = async (buffer, samplingRate) => {
	const keys = range(0, buffer.length / 2 - 1)
	const v = keys.map((key, index) => getVoltage(buffer.slice(index * 2, index * 2 + 2)))
	const t = range(0, v.length - 1).map((time) => time / samplingRate)

	// render only max 800 samples
	const limit = 800
	const factor = Math.ceil(t.length / limit)

	const tDownSampled = t.filter((time, index) => index % factor === 0)
	const vDownSampled = v.filter((voltage, index) => index % factor === 0)
	return { t: tDownSampled, v: vDownSampled }
}

